<template>
  <settings>
    <loader v-if="loading"></loader>
    <section v-if="!loading" class="box-view-component">
      <div class="card mb-5" :class="mainPaddingClass">
        <div class="py-sm-4 px-3 pr-sm-0 mb-5">
          <div class="pt-0 pb-3">
            <router-link
              class="nav-link px-0"
              :to="{ name: boxInfoRoutName, params: { deviceId: deviceIdInternal } }"
            >
              <div class="text-muted h7">
                <svg-icon name="chevron-left" size="20"></svg-icon>
                {{ item.digitalThing.name }}
              </div>
            </router-link>
          </div>
          <div class="d-flex justify-content-between align-items-bottom">
            <div>
              <h2>{{ $t('settings.settings') }}</h2>
            </div>
            <div class="text-muted text-right caption">
              <p class="caption">{{ item.digitalThing.workCenter.itObject.name }}</p>
              <p class="caption">
                <span class="pr-2 py-0">{{ $t('box.startDate') }}</span>
                <span>{{ startDate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="!size" id="menuContainer" class="menuContainer mb-2 px-2">
          <div id="menu-inner-container">
            <model-select
              class="py-3 select-tab model-select-icon"
              v-model="selectedTabMobile"
              :options="settingsTabs"
            ></model-select>
          </div>
        </div>
        <div class="p-3" v-if="!size">
          <box-main-settings
            v-if="selectedTabMobile == tabGeneralValue"
            :accessToChange="accessToChange"
            :deviceId="deviceIdInternal"
            :item="item"
          />
          <all-sensors
            v-if="selectedTabMobile == tabSensorValue && isProBoxModel"
            :workCenterId="workCenterId"
          ></all-sensors>
          <box-reports
            v-if="selectedTabMobile == tabReportsValue"
            :deviceId="deviceIdInternal"
            :work-center-id="workCenterId"
          ></box-reports>
          <box-notifications
            v-if="selectedTabMobile == tabNotificationsValue"
            :deviceId="deviceIdInternal"
            :workCenterId="workCenterId"
          ></box-notifications>
          <box-shifts
            v-if="selectedTabMobile == tabShiftsValue"
            :workCenterId="workCenterId"
          ></box-shifts>
          <box-operating-modes
            v-if="selectedTabMobile == tabOperatingModesValue"
            :deviceId="deviceIdInternal"
            :workCenterId="workCenterId"
          />
        </div>
        <b-tabs
          v-if="size"
          v-model="choosedComponent"
          :vertical="size"
          justified
          lazy
          no-nav-style
          class="px-0 settings-tab"
        >
          <b-tab>
            <template #title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('settings.main') }}</span>
              </div>
            </template>
            <div>
              <div v-if="item" class="pl-xl-5 pl-lg-0">
                <box-main-settings
                  :access-to-change="accessToChange"
                  :device-id="deviceIdInternal"
                  :item="item"
                />
              </div>
            </div>
          </b-tab>
          <b-tab v-if="isProBoxModel">
            <template v-slot:title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('settings.sensor') }}</span>
              </div>
            </template>
            <all-sensors :workCenterId="workCenterId" class="pl-xl-5 pl-lg-0"></all-sensors>
          </b-tab>
          <b-tab v-if="hasReportsFeature">
            <template v-slot:title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('settings.reports') }}</span>
              </div>
            </template>
            <box-reports
              :deviceId="deviceIdInternal"
              :work-center-id="workCenterId"
              class="pl-xl-5 pl-lg-0"
            ></box-reports>
          </b-tab>
          <b-tab v-if="hasNotificationFeature">
            <template v-slot:title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('notifications.header') }}</span>
              </div>
            </template>
            <box-notifications
              class="pl-xl-5 pl-lg-0"
              :device-id="deviceIdInternal"
              :work-center-id="workCenterId"
            ></box-notifications>
          </b-tab>
          <b-tab v-if="hasShiftsFeature">
            <template v-slot:title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('settings.shift') }}</span>
              </div>
            </template>
            <box-shifts
              v-if="workCenterId"
              :work-center-id="workCenterId"
              class="pl-xl-5 pl-lg-0"
            ></box-shifts>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <div class="text-left w-100 p-2">
                <span class="h7">{{ $t('settings.operatingModes') }}</span>
              </div>
            </template>
            <box-operating-modes
              :deviceId="deviceIdInternal"
              :workCenterId="workCenterId"
              class="pl-xl-5 pl-lg-0"
            />
          </b-tab>
        </b-tabs>
      </div>
    </section>
  </settings>
</template>

<script>
import boxeQuery from '@/api/boxinfo/boxInfoSettings.gql';
import moment from 'moment';
import { vueWindowSizeMixin } from 'vue-window-size';
import { BOXMODEL_PRO } from '@/utils/const.js';
export default {
  name: 'SmartOeeSettingsBox',
  components: {
    boxOperatingModes: () => import('@/components/settings/OperatingModes/BoxOperatingModes'),
    boxShifts: () => import('@/components/settings/Shifts/BoxShifts'),
    boxNotifications: () => import('@/components/settings/Notifications/BoxNotifications'),
    boxReports: () => import('@/components/settings/Reports/BoxReports'),
    boxMainSettings: () => import('@/components/settings/Main/BoxMainSettings'),
    allSensors: () => import('@/components/settings/Sensors/AllSensors'),
  },
  mixins: [vueWindowSizeMixin],
  data() {
    return {
      boxInfoRoutName: 'Boxinfo',
      query: boxeQuery,
      trixmodel: 'Content',
      editMode: false,
      deletingBox: false,
      choosedComponent: 0,
      selectedTabMobile: 'general',
      tabGeneralValue: 'general',
      tabSensorValue: 'sensors',
      tabReportsValue: 'reports',
      tabNotificationsValue: 'notifications',
      tabShiftsValue: 'shifts',
      tabOperatingModesValue: 'operatingModes',
    };
  },
  apollo: {
    item: {
      query: boxeQuery,
      variables() {
        return {
          deviceId: this.deviceIdInternal,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).boxes[0] || {};
      },
      skip() {
        return !this.deviceIdInternal;
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  computed: {
    mainPaddingClass() {
      return this.size && this.windowWidth < 1100
        ? 'settingsPaddingMobile'
        : this.size
        ? 'settingsPadding'
        : '';
    },
    isProBoxModel() {
      return BOXMODEL_PRO === this.item?.model?.id;
    },
    settingsTabs() {
      const tabs = [
        { text: this.$t('settings.main'), value: this.tabGeneralValue, sorted: 0 },
        { text: this.$t('settings.operatingModes'), value: this.tabOperatingModesValue, sorted: 5 },
      ];

      if (this.isProBoxModel) {
        tabs.push({ text: this.$t('settings.sensor'), value: this.tabSensorValue, sorted: 1 });
      }

      if (this.hasReportsFeature) {
        tabs.push({ text: this.$t('settings.reports'), value: this.tabReportsValue, sorted: 2 });
      }
      if (this.hasNotificationFeature) {
        tabs.push({
          text: this.$t('notifications.header'),
          value: this.tabNotificationsValue,
          sorted: 3,
        });
      }
      if (this.hasShiftsFeature) {
        tabs.push({ text: this.$t('settings.shift'), value: this.tabShiftsValue, sorted: 4 });
      }
      return tabs.sort((itemFirst, itemSecond) => itemFirst.sorted - itemSecond.sorted);
    },
    size() {
      return this.windowWidth > 775;
    },
    loading() {
      return this.$apollo.queries.item.loading || this.deletingBox;
    },
    accessToChange() {
      return this.$store.getters.isAdmin;
    },
    deviceIdInternal() {
      return this.$route.params.boxId;
    },
    workCenterId() {
      return this.item && this.item.digitalThing && this.item.digitalThing.workCenter
        ? this.item.digitalThing.workCenter.id
        : null;
    },
    hasReportsFeature() {
      return this.hasBoxFeature(this.deviceIdInternal, 'reports');
    },
    hasNotificationFeature() {
      return this.hasBoxFeature(this.deviceIdInternal, 'notifications');
    },
    hasShiftsFeature() {
      return this.hasBoxFeature(this.deviceIdInternal, 'shifts');
    },
    startDate() {
      return this.item.startDate
        ? moment(this.item.startDate).format('DD.MM.YYYY')
        : moment(0).format('DD.MM.YYYY');
    },
  },
  methods: {
    toLocaleDateString(dateStr) {
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>

<style lang="scss" scoped>
.box-view-component :deep {
  .boxsettingstabs {
    background: #434a54;
  }
  .settings-tab {
    .nav-item {
      .active {
        border-left: 2px solid #ff6d0b;
        background-color: #17181d;
        span {
          color: #ffffff;
        }
      }
      span {
        color: #979ba7;
      }
    }
  }
  .settingsPadding {
    padding-right: 72px;
    padding-left: 72px;
  }
  .settingsPaddingMobile {
    padding-right: 20px;
    padding-left: 20px;
  }

  #menuContainer {
    display: inline-block;
    white-space: nowrap;
    width: 100%;
  }
  #menu-inner-container {
    width: 95%;
    margin: 0 auto;
  }
  #menuContainer button {
    display: inline-block;
  }
  ::-webkit-scrollbar {
    width: 1; /* Remove scrollbar space */
    height: 0;
  }
  #menu:active,
  #menu:hover {
    box-shadow: -4px -4px 4px #1e2129, 4px 4px 4px #14171d !important;
    background-color: #191c24;
  }
  #menuContainer button.btn-third:hover {
    color: #fff;
    background-color: #191c24;
    border-color: #191c24;
  }
  .ui.search.selection.dropdown.select-tab {
    border-radius: 4px;
    position: relative;
    .menu.visible {
      &::-webkit-scrollbar {
        width: 0px;
      }
    }
    .text {
      font-size: 16px;
    }
  }
}
</style>
